(function() {
  'use strict';

  function BasicFormController($rootScope, $translate, Form) {
    var ctrl = this;

    ctrl.form = new Form();

    ctrl.form.addField({
      id: 'title',
      type: 'string',
      label: $translate.instant('Template title'),
      required: true,
      onChange: function($viewValue) {
        $rootScope.$broadcast('KZTemplate:FormChanged', { title: $viewValue });
      }
    });
  }

  function BasicFormDirective() {
    return {
      scope: {
        template: '='
      },
      restrict: 'AE',
      templateUrl: 'app/components/dashboard-templates/directives/form.html',
      controller: BasicFormController,
      controllerAs: 'ctrl'
    };
  }

  BasicFormController.$inject = [
    '$rootScope',
    '$translate',
    'FormsService'


  ];

  angular.module('component.dashboardTemplates')
    .directive('dashboardTemplateBasicForm', BasicFormDirective);
})();
